import { apiFetch } from '../../../shared/apiClient';

export interface EstimationSettings {
  targetDeviationPct: number;
  toleranceMultiplier: number;
}

export interface EstimationOverride {
  productId: string;
  productName: string;
  settings: EstimationSettings;
}

export interface EffectiveEstimationSettings {
  settings: EstimationSettings;
  isOverride: boolean;
}

export const EstimationApi = {
  async getOrgEstimationSettings(): Promise<{ settings: EstimationSettings }> {
    const res = await apiFetch('/api/estimation/settings/org');
    if (!res.ok) throw new Error(`Failed to fetch org estimation settings: ${res.statusText}`);
    return res.json();
  },

  async getEstimationOverrides(): Promise<{ overrides: EstimationOverride[] }> {
    const res = await apiFetch('/api/estimation/settings/overrides');
    if (!res.ok) throw new Error(`Failed to fetch estimation overrides: ${res.statusText}`);
    return res.json();
  },

  async saveOrgEstimationSettings(
    settings: EstimationSettings
  ): Promise<{ settings: EstimationSettings }> {
    const res = await apiFetch('/api/estimation/settings/org', {
      method: 'PUT',
      body: JSON.stringify(settings),
    });
    if (!res.ok) throw new Error(`Failed to save org estimation settings: ${res.statusText}`);
    return res.json();
  },

  async saveEstimationOverride(
    productId: string,
    settings: EstimationSettings
  ): Promise<{ settings: EstimationSettings; isOverride: boolean }> {
    const res = await apiFetch(
      `/api/estimation/settings/overrides/${encodeURIComponent(productId)}`,
      {
        method: 'PUT',
        body: JSON.stringify(settings),
      }
    );
    if (!res.ok) throw new Error(`Failed to save estimation override: ${res.statusText}`);
    return res.json();
  },

  async deleteEstimationOverride(productId: string): Promise<void> {
    const res = await apiFetch(
      `/api/estimation/settings/overrides/${encodeURIComponent(productId)}`,
      { method: 'DELETE' }
    );
    if (!res.ok) throw new Error(`Failed to reset estimation override: ${res.statusText}`);
  },

  async getEffectiveEstimationSettings(): Promise<EffectiveEstimationSettings> {
    const res = await apiFetch('/api/estimation/settings/effective');
    if (!res.ok) {
      throw new Error(`Failed to fetch effective estimation settings: ${res.statusText}`);
    }
    return res.json();
  },
};
